/**
 * design_handoff_accept_invitation §4 — screen 2 (Create account). Thin
 * wrapper around the shared EmailSignUpForm: no Workspace field (joining,
 * not creating), Email locked to the invited address, submit button reads
 * "Join {workspace}".
 *
 * @param {{uuid: string, name: string, icon?: string}} organization
 * @param {string=} role
 * @param {string} email
 * @param {string} invitationHash
 * @param {function} onJoined - called after a successful, already-verified registration
 */
import React from "react";
import EmailSignUpForm from "../RegisterPage/EmailSignUpForm";
import WorkspaceContextLine from "./WorkspaceContextLine";

const CreateAccountScreen = ({
  organization,
  role,
  email,
  invitationHash,
  onJoined,
}) => (
  <EmailSignUpForm
    heading="Create your account"
    subtitle={<WorkspaceContextLine organization={organization} role={role} />}
    displayOrganizationName={false}
    displayCouponLink={false}
    emailReadOnly
    emailHint="The invitation was sent here, so there's no confirmation step."
    submitBtnText={`Join ${organization.name}`}
    formValues={{
      email,
      organization_uuid: organization.uuid,
      invitationHash,
    }}
    onRegisterSuccess={onJoined}
  />
);

export default CreateAccountScreen;
